module.exports = __webpack_public_path__ + "img/linkedin.a62d7689.svg";